const getEventMessage = (event: unknown): string => {
  const maybeEventMessage = event instanceof Error ? event.message : event

  return typeof maybeEventMessage === 'string' ? maybeEventMessage : ''
}

export default getEventMessage
